var image_viewer_rtlignore_default = {
  "fontElementMap": "THq9L",
  "imageContainer": "yrpQK",
  "expandContainer": "AJDpy",
  "expandIcon": "D3Xvo",
  "pointer": "MYYaD",
  "imageWrapper": "YgO18",
  "imageRatio": "_7cQp8",
  "image": "NgSGq",
  "imageOverlay": "tG5Rn",
  "imageCaption": "JF9rE",
  "imagePreload": "MZHAP",
  "imageHighres": "E4yie",
  "onlyHighRes": "iPdbO",
  "image_loading": "_3t1ch"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
